import { render, staticRenderFns } from "./ChatGPTActionPlaceholder.vue?vue&type=template&id=075619b4&scoped=true&"
import script from "./ChatGPTActionPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ChatGPTActionPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ChatGPTActionPlaceholder.vue?vue&type=style&index=0&id=075619b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075619b4",
  null
  
)

export default component.exports